import T6 from "../../components/ExcerciseTypes/TypeIn/T6";
import Circle_Write from '../../components/ExcerciseTypes/Circle_Write';

const json = {
  1: {
    unit: "Unit Starter",
    id: "FP8-WB-demo-2023-US-P5-E1",
    audio: "",
    video: "",
    // recorder: true,
    exerciseKey: "/img/FriendsPlus/Page5/Key/E1answerKey.jpg",
    component: T6,
    textAlign: "center",
    // maxLength: 1,
    inputSize: 81,
    stylesTextInput: {
		  background: "transparent",
		  border: "none",
		  borderBottom: "1px solid gray",
		  fontSize: "19px",
		  textAlign: "center",
		},
    titleQuestion: [
      {
        num: "1",
        title: `
        Complete the table with the word.
				`,
        color: "rgb(29,193,215)",
        star:1
      },
    ],
    
    questionImage: [],
    // hideBtnFooter: true,
    isHiddenCheck: true,
    questions: [
      {
        title: `
            <div style='margin-top: 20px; display: flex; gap: 30px;max-width:580px;margin-left:190px'>
							<div style='flex: 1; border-radius: 20px; padding: 20px 30px; border: 3px solid rgb(169,225,236);'>
								<div><span style="margin-right:20px">aren't</span><span style="margin-right:20px"> do</span><span style="margin-right:20px"> does</span><span style="margin-right:20px"> doesn't</span><span style="margin-right:20px;text-decoration:line-through"> don't</span><span> has</span></div>
								<div><span style="margin-right:20px; margin-left:30px">have</span><span style="margin-right:20px"> having</span><span style="margin-right:20px"> is</span><span style="margin-right:20px"> isn't</span><span style="margin-right:20px"> 'm</span><span> 're</span></div>
							</div>
              
            </div>
            <div style='position: relative;'>
							<div style='display:flex'>
									<img src="/img/FriendsPlus/Page5/E1/1.jpg" style='height:26cm;'  >
							</div>
          		<div style=" position: absolute; top: 229px; left: 30px; "><input id='0' style="width:0px"></input></div>
          		<div style=" position: absolute; top: 309px; left: 350px; "><input id='1' style="width:0px"></input></div>
          		<div style=" position: absolute; top: 309px; left: 475px; "><input id='2' style="width:0px"></input></div>
          		<div style=" position: absolute; top: 389px; left: 34px; "><input id='3' style="width:0px"></input></div>
          		<div style=" position: absolute; top: 532px; left: 325px; "><input id='4' style="width:0px"></input></div>
          		<div style=" position: absolute; top: 587px; left: 328px; "><input id='5' style="width:0px"></input></div>
          		<div style=" position: absolute; top: 532px; left: 581px; "><input id='6' style="width:0px"></input></div>
          		<div style=" position: absolute; top: 723px; left: 34px; "><input id='7' style="width:0px"></input></div>
          		<div style=" position: absolute; top: 803px; left: 381px; "><input id='8' style="width:0px"></input></div>
          		<div style=" position: absolute; top: 883px; left: 44px; "><input id='9' style="width:0px"></input></div>
          		
          		
          
						</div>
        `,
        answer: ["Do",  "has",  "doesn't",  "Does" , "'m",  "'re", 
           "having",  "aren't" , "isn't",  "Is"
          
        ],
      },
    ],
  },
  2: {
    unit: "Unit Starter",
    id: "FP8-WB-demo-2023-US-P5-E2",
    audio: "",
    video: "",
    // recorder: true,
    exerciseKey: "/img/FriendsPlus/Page5/Key/E2answerKey.jpg",
    component: Circle_Write,
    textAlign: "center",
    // maxLength: 1,
    inputSize: 80,
    titleQuestion: [
      {
        num: "2",
        title: `
        Choose the correct words.
				`,
        color: "rgb(29,193,215)",
        star:2
      },
    ],
    questionImage: [],
    // hideBtnFooter: true,
    isHiddenCheck: true,
    
    question: {
      Write: {
        inputStyle: {},
        answers: [],
        initialValue: [],
      },
      Circle: {
        initialWordStyle: {
          margin: '5 10',
          border: 'none',
          borderColor: 'transparent',
          borderRadius: '60%',
          padding:'5px'
        },
        selectWordStyle: {
          border: 'solid 3px',
          borderColor: '#00a8ec',
          margin: '-2px',
        },
        limitSelect: 1,
        listWords: [
          "Does / Are / Is",
          " are_they_wanting / do_they_want / they_want ",
          " doesn’t_like / not_like / isn’t_liking",
          " do / enjoy / am",
          " Does_Anna_have / Has_Anna / Is_Anna_having ",
          " chats / ’s_chatting / does_chat",
          "does_the_bus_leave / the_bus_leaves / is_the_bus_leaving"
        ],
        answers: ['0-0', '1-6', '2-2', '3-10', '4-2', '5-6', '6-0'],
        initialValue: [],
      },
      Layout: /*html */ `
      <div style='line-height:2.5'>
       <div style="display: flex; column-gap: 20px;">
        <strong></strong>
        <div>
        I’m having problems sleeping <strong><span style=" border: 3px solid black;border-radius: 25px;">at the moment</span> / always / yesterday.</strong>
        </div>
       </div>
       <div style="display: flex; column-gap: 20px;">
        <strong>1</strong>
        <div>
          <strong><input id="0" type="Circle" /></strong> Aaron usually get up early?
        </div>
       </div>
       <div style="display: flex; column-gap: 20px">
        <strong>2</strong>
        <div>
        What time <strong><input id="1" type="Circle" /></strong> to leave?
        </div>
       </div>
       <div style="display: flex; column-gap: 20px">
        <strong>3</strong>
        <div>
        He <strong> id="2" type="Circle" /></strong> maths.

        </div>
       </div>
       <div style="display: flex; column-gap: 20px">
        <strong>4</strong>
        <div>
        ‘Are you enjoying the book?’ ‘Yes, I <strong><input id="3" type="Circle" /></strong>'.
        </div>
       </div>
       <div style="display: flex; column-gap: 20px">
        <strong>5</strong>
        <div>
          <strong><input id="4" type="Circle" /></strong> more than one mobile phone?
        </div>
       </div>
       <div style="display: flex; column-gap: 20px">
        <strong>6</strong>
        <div>
        Right now, she <strong><input id="5" type="Circle" /></strong> to her friends.
        </div>
       </div>
       <div style="display: flex; column-gap: 20px">
        <strong>7</strong>
        <div>
        ‘When <strong><input id="6" type="Circle" /></strong> ’ ‘At 7.45 every morning.’
        </div>
       </div>
      
      </div>
      `,
    },
  },
  3: {
    unit: "Unit Starter",
    id: "FP8-WB-demo-2023-US-P5-E3",
    audio: "",
    video: "",
    // recorder: true,
    exerciseKey: "/img/FriendsPlus/Page5/Key/E3answerKey.jpg",
    component: T6,
    textAlign: "center",
    // maxLength: 1,
    inputSize: 180,
    titleQuestion: [
      {
        num: "3",
        title: `
        Complete the postcard using the correct 
        form of the verbs.
				`,
        color: "rgb(3, 103, 181)",
        star:2
      },
    ],
    questionImage: [],
    // hideBtnFooter: true,
    isHiddenCheck: true,
    questions: [
      {
        title: `
        <div style='margin-top: 20px; display: flex; gap: 30px;margin-left:200px'>
        <div style='flex: 1; border-radius: 20px; padding: 20px 30px; border: 4px solid rgb(169,225,236);max-width:600px'>
          <div><span style="margin-right:35px">come</span><span style="margin-right:35px">not get up</span><span style="margin-right:35px"> go</span><span style="margin-right:35px"> go</span><span style="margin-right:35px"> have</span><span> help</span></div>
          <div><span style="margin-right:35px; margin-left:55px">stay</span><span style="margin-right:35px">wake up</span><span style="margin-right:35px;text-decoration:line-through">write</span><span style="margin-right:35px">you/do</span></div>
        </div>
        
      </div>
      <div style='position: relative;'>
        <div style='display:flex'>
            <img src="/img/FriendsPlus/Page5/E3/1.jpg" style='height:26cm;'  >
        </div>
        <div style=" position: absolute; top: 240px; left: 74px; "><input id='0' style="width:0px"></input></div>
        <div style=" position: absolute; top: 319px; left: 275px; "><input id='1' style="width:0px"></input></div>
        <div style=" position: absolute; top: 440px; left: 350px; "><input id='2' style="width:0px"></input></div>
        <div style=" position: absolute; top: 559px; left: 110px; "><input id='3' style="width:0px"></input></div>
        <div style=" position: absolute; top: 600px; left: 147px; "><input id='4' style="width:0px"></input></div>
        <div style=" position: absolute; top: 720px; left: 213px; "><input id='5' style="width:0px"></input></div>
        <div style=" position: absolute; top: 761px; left: 359px; "><input id='6' style="width:0px"></input></div>
        <div style=" position: absolute; top: 801px; left: 210px; "><input id='7' style="width:0px"></input></div>
        
        
        
    
      </div>
        `,
        answer: [
         "'m staying" , "'re having",  "wakes up",  "don't get up", 
 "go",  "'m going",  "'s helping" , "are you doing" 
        ],
      },
    ],
  },
  4: {
    unit: "Unit Starter",
    id: "FP8-WB-demo-2023-US-P5-E4",
    audio: "",
    video: "",
    // recorder: true,
    // exerciseKey: "img/FriendsPlus/Page5/E4/Key/answerKey.png",
    component: T6,
    textareaStyle: { width: 740 },
    hideBtnFooter:true,
    questionImage: [],
    titleQuestion: [
      {
        num: "4",
        title: `
        Answer the questions. Write three or 
four complete sentences
				`,
        color: "rgb(3, 103, 181)",
        star:3
      },
    ],
    questions: [
      {
        title: `
        <div>
          <div>How often do you cook? Who’s cooking dinner<br>
          tonight? What food do you like and dislike?</div>
          <div><strong>I don’t cook very often. My dad is cooking dinner tonight.<br>
          I like pasta and pizza, but I don’t like fish.</strong>
          </div>
          <div><strong style="margin-right:10px">1 </strong>Where do you usually go on holiday? Who do <br>
          you go with and what do you do there?</div>
          <textarea id="0" rows="3"></textarea>
          <div><strong style="margin-right:10px">2 </strong>What’s your best friend doing now? What do <br>
          you think your parents are doing now?</div>
          <textarea id="1" rows="3"></textarea>
        </div>
        
        `,
        answer: [""],
      },
    ],
  },
};

export default json;
